import React from "react";
import styles from "./RepositoryStatus.module.sass";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { Link } from "react-router-dom";
import { checkRoles } from "colbi_web_ui/lib/utils/roleValidator";
import Chevron from "colbi_web_ui/lib/components/Chevron/Chevron";
import { UserRoles } from "../../enums/userRoles";
import { handleReprocessRepository } from "../../actions/UserActions/HandleUserActions";
import { stringifyFilter } from "colbi_web_ui/lib/utils";
import { SovosBox } from "mosaic-react";

const RepositoryStatus = (props) => {
    const { modules } = props;
    const {
        i18n,
        params,
        reload,
        pushDialog,
        user,
        repositoryStatus,
        reprocessRepository,
        pushNotification,
    } = useGlobalValue();
    const { projectId, locale } = params;

    function functionCheckTypeOfAlert(repositoryStatus) {
        if (repositoryStatus) {
            const fiscalYearLabel = repositoryStatus.fiscalYear;
            const fileTypeLabel = repositoryStatus.fileType;

            const linkToNavigate = `/${locale}/${projectId}/${repositoryStatus.fiscalYear}/full/repository/merge_collisions?filter=${stringifyFilter(
                [
                    { column: "FiscalYear", filters: [{ value: fiscalYearLabel }], operator: "" },
                    { column: "Type", filters: [{ value: fileTypeLabel }], operator: "" },
                ],
            )}`;

            switch (repositoryStatus.repoStatus) {
                case 1:
                    if (repositoryStatus.autoMerge) {
                        return (
                            <div className={styles["alert-process-repository"]}>
                                <p>{i18n`inconsistent repository please wait for the processing of the repository for the year ${fiscalYearLabel} and type ${fileTypeLabel}`}</p>
                                <div className={styles["btns-actions"]}>
                                    <Link className={styles["link"]} to={linkToNavigate}>
                                        <small>
                                            <strong>{i18n`See Inconsistencies in the Repository`}</strong>
                                        </small>
                                        <Chevron direction="right" />
                                    </Link>
                                </div>
                            </div>
                        );
                    }
                    return (
                        <div className={styles["alert-process-repository"]}>
                            <p>{i18n`inconsistent repository please process all the files for year ${fiscalYearLabel} and type ${fileTypeLabel}`}</p>
                            <div className={styles["btns-actions"]}>
                                {checkRoles(user, [
                                    UserRoles.ADMIN,
                                    UserRoles.OWNER,
                                    UserRoles.WRITER,
                                    UserRoles.PP_SUPPORT,
                                    UserRoles.SUPPORT,
                                ]) ? (
                                    <small
                                        onClick={() => {
                                            handleReprocessRepository({
                                                pushDialog,
                                                i18n,
                                                reload,
                                                params,
                                                reprocessRepository,
                                                user,
                                                repositoryStatus,
                                                pushNotification,
                                            });
                                        }}
                                    >
                                        <strong>{i18n`Process Repository`}</strong>
                                    </small>
                                ) : (
                                    <div />
                                )}
                                <Link className={styles["link"]} to={linkToNavigate}>
                                    <small>
                                        <strong>{i18n`see inconsistencies in the repository`}</strong>
                                    </small>
                                    <Chevron direction="right" />
                                </Link>
                            </div>
                        </div>
                    );
                case 2:
                    return (
                        <div className={styles["alert-status-repository"]}>
                            <p>{i18n`your repository for year ${fiscalYearLabel} and type ${fileTypeLabel} is being reprocessed you may see some inconsistencies during this process`}</p>
                        </div>
                    );

                default:
                    break;
            }
        }
        return undefined;
    }

    const checkSubmissionModule = (modules || []).includes("merge_collisions");
    return (<SovosBox sx={{ position: "absolute", top: 0, left: 0, right: 0, overflowX: "hidden" }}>
        {checkSubmissionModule ? functionCheckTypeOfAlert(repositoryStatus)
            : null}
    </SovosBox>)
};

export default RepositoryStatus;
